
import request from '@/utils/request'
// 获取分类列表
export function getCategoryList(params) {
    return request({
        url: '/v1/goods_category/getList',
        method: 'get',
        params,
    })
}
// 获取商品列把你
export function getGoodsList(params) {
    return request({
        url: '/v1/goods/getList',
        method: 'get',
        params,
    })
}